import {
    Backdrop,
    Box,
    Button,
    makeStyles,
    Menu,
    MenuItem,
    Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import iconoPrestador from '../../../assets/iconos/play.png';

import styles from "./styles";
const useStyles = makeStyles(styles);

export default function Tutoriales() {
    const classes = useStyles();

    const tutoriales = [
        {
            titulo: "¿Cómo presentar una liquidación?",
            videoId: "zJfHTRXk3IQ",
        },
        {
            titulo: "¿Cómo presentar una factura?",
            videoId: "T5t-zJ1Tjzw",
        },
        {
            titulo: "¿Cómo facturar las internaciones? (Masivo)",
            videoId: "NalMfH-tKiQ",
        },
        {
            titulo: "¿Cómo facturar las internaciones? (Manual)",
            videoId: "E9IKqOwPcW8",
        },
    ];

    const [anchorEl, setAnchorEl] = useState(null);
    const [currentVideo, setCurrentVideo] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenVideo = (videoId) => {
        handleClose();
        setCurrentVideo(videoId);
    };

    const handleCloseVideo = () => {
        setCurrentVideo(null);
    };

    useEffect(() => {
        if (currentVideo) {
            document.body.style.overflow = "hidden";
            document.body.style.paddingRight = "17px";
            document.getElementsByClassName(
                "MuiAppBar-root"
            )[0].style.paddingRight = "17px";
        } else {
            document.body.style.removeProperty("overflow");
            document.body.style.removeProperty("padding-right");
            document
                .getElementsByClassName("MuiAppBar-root")[0]
                .style.removeProperty("padding-right");
        }
    }, [currentVideo]);

    return (
        <>
            <Button className={classes.button} onClick={handleClick}>
                Ver Tutoriales
            </Button>
            <Menu
                classes={{ paper: classes.menu }}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {tutoriales.map((tutorial, index) => (
                    <MenuItem
                        key={index}
                        className={classes.menuItem}
                        onClick={() => handleOpenVideo(tutorial.videoId)}
                    >
                        <Typography className={classes.menuTitulo}>
                            {tutorial.titulo}
                        </Typography>
                        <img
                            src={iconoPrestador}
                            className={classes.videoThumbnail}
                        />
                    </MenuItem>
                ))}
            </Menu>
            <Backdrop
                classes={{ root: classes.backdrop }}
                open={!!currentVideo}
                onClick={handleCloseVideo}
            >
                <CloseIcon className={classes.videoClose} />
                <iframe
                    width="970"
                    height="490"
                    src={`https://www.youtube.com/embed/${currentVideo}?autoplay=1`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </Backdrop>
        </>
    );
}
